export default __webpack_public_path__ + "static/media/fromthebeyond.60ca6c49.png";